const ENDPOINT = process.env.REACT_APP_ENDPOINT

async function getMediaById(mediaId){
    const baseUrl = `${ENDPOINT}/media`;
    const url = `${baseUrl}/${mediaId}`;

    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('There has been a problem with your fetch operation:', error);
    }
}

export default getMediaById;